const formatNumber = number => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

const handleToggle = (calculation, value) => {
    const result = calculation.querySelector('.js-question-form-calculation-result');
    const resultNumber = calculation.querySelector('.js-question-form-calculation-result-number');
    const resultPlaceholder = calculation.querySelector('.js-question-form-calculation-result-placeholder');
    const resultFinal = calculation.querySelector('.js-question-form-calculation-result-number-final');

    if (!result || !resultNumber || !resultPlaceholder) {
        return;
    }

    if (value !== '') {
        resultPlaceholder.style.display = 'none';

        result.style.display = 'inline-block';
        resultNumber.innerHTML = formatNumber(value);
        resultFinal.value = formatNumber(value);
    }
};

const calculate = (calculation, number, answer, modifier) => {
    const numberValue = parseFloat(number.value);
    const answerValue = parseFloat(answer);
    const modifierValue = parseFloat(modifier.value);

    if (isNaN(numberValue) || isNaN(answerValue) || isNaN(modifierValue)) {
        return;
    }

    let resultValue = numberValue * modifierValue * answerValue;

    handleToggle(calculation, resultValue);
};

const initCalculation = () => {
    let selectedAnswer = 0;

    const calculations = document.querySelectorAll('.js-question-form-calculation');
    for (const calculation of calculations) {
        const number = calculation.querySelector('.js-question-form-calculation-number');
        const answers = calculation.querySelectorAll('.js-question-form-calculation-answer');
        const modifier = calculation.querySelector('.js-question-form-calculation-modifier');

        if (!number || !answers || !modifier) {
            return;
        }

        for (const answer of answers) {
            answer.addEventListener('change', () => {
                selectedAnswer = answer.dataset.number ?? 0;

                calculate(calculation, number, selectedAnswer, modifier);
            });
        }

        number.addEventListener('change', () => calculate(calculation, number, selectedAnswer, modifier));
    }
};

const preventSubmitOnNumber = () => {
    const numberField = document.querySelector('.js-question-form-calculation-number');
    if (!numberField) {
        return;
    }

    numberField.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            // Do not submit form
            e.preventDefault();

            // Trigger change event
            const event = new Event('change');
            numberField.dispatchEvent(event);
        }
    });
};

document.addEventListener('DOMContentLoaded', function () {
    initCalculation();
    preventSubmitOnNumber();
});
